import { useEffect, useState } from 'react';
import * as R from 'ramda';
import { Modal } from "react-bootstrap";
import DateSelector from '../components/dumb/form/DateSelector';
import {
  LeadStageOptions,
  ActionType,
  CallResult,
  IndustryOptions,
  ExperienceOptions,
  ProfessionOptions
} from '../constants/sales';

function UpdateLeadForm({ leadId, name, email, leadStage, leadProfile: leadProfile, hideModal, onSubmit }) {
  const [updateValue, setUpdateValue] = useState('');
  const [newLeadStage, setNewLeadStage] = useState(leadStage);
  const [actionType, setActionType] = useState(ActionType.keys.CALL);
  const [currentIndustry, setCurrentIndustry] = useState(leadProfile['currentIndustry']);
  const [currentProfession, setCurrentProfession] = useState(leadProfile['currentProfession']);
  const [currentExperience, setCurrentExperience] = useState(leadProfile['currentExperience']);
  const [demoDate, setDemoDate] = useState(undefined);
  const [callResult, setCallResult] = useState(CallResult[0].value);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    console.log(`actionType = ${actionType} and callResult = ${callResult}`);
    if (actionType === ActionType.keys.CALL) {
      setIsFormValid(!R.isNil(callResult) && callResult !== CallResult[0].value);
    }
    else if (actionType === ActionType.keys.DEMO_BOOKED) {
      setIsFormValid(!R.isNil(demoDate));
    }
    else if (actionType === ActionType.keys.PROFILE) {
      setIsFormValid(true);
    }
  }, [newLeadStage, updateValue, actionType, demoDate, callResult])

  return (
    <Modal size="lg" centered show={true} onHide={() => hideModal()}>
      <Modal.Header closeButton>
        <Modal.Title>
          Update Lead Status
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label>Lead ID</label>
          <input
            type="text"
            className="form-control"
            id="leadId"
            value={leadId}
            disabled
          />
        </div>
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            className="form-control"
            id="name"
            value={name}
            disabled
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="text"
            className="form-control"
            id="email"
            value={email}
            disabled
          />
        </div>
        <div className="form-group" style={{ marginTop: '20px' }}>
          <label> Update Type </label>
          <select
            value={actionType}
            onChange={e => setActionType(e.target.value)}
          >
            {
              ActionType.types.map(actionType =>
                <option key={actionType.key} value={actionType.key}> { actionType.display } </option>
              )
            }
          </select>
        </div>
        {
          actionType === ActionType.keys.DEMO_BOOKED
          && (
            <div className="form-group">
              <label> Demo Date </label>
              <DateSelector
                selectDate={date => setDemoDate(date)}
              />
            </div>
          )
        }
        {
          actionType === ActionType.keys.CALL && (
            <div className="form-group">
              <label>Update</label>
              <textarea
                rows="3"
                className="form-control"
                id="updateValue"
                onChange={(e) => setUpdateValue(e.target.value)}
              />
            </div>
          )
        }
        {
          actionType === ActionType.keys.CALL
          && (
            <div className="form-group">
              <label> Call Result </label>
              <select
                value={callResult}
                onChange={e => setCallResult(e.target.value)}
              >
                {
                  CallResult.map(callResult => <option key={callResult.value} value={callResult.value}> { callResult.display } </option>)
                }
              </select>
            </div>
          )
        }
        {
          actionType === ActionType.keys.PROFILE
          && (
            <div className={"form-group"}>
              <label> Current Industry </label>
              <select
                value={currentIndustry}
                onChange={e => setCurrentIndustry(e.target.value)}
              >
                {
                  IndustryOptions.options.map(option => <option key={option.key} value={option.key}> { option.display } </option>)
                }
              </select>
            </div>
          )
        }
        {
          actionType === ActionType.keys.PROFILE
          && (
            <div className={"form-group"}>
              <label> Current Experience </label>
              <select
                value={currentExperience}
                onChange={e => setCurrentExperience(e.target.value)}
              >
                {
                  ExperienceOptions.options.map(option => <option key={option.key} value={option.key}> { option.display } </option>)
                }
              </select>
            </div>
          )
        }
        {
          actionType === ActionType.keys.PROFILE
          && (
            <div className={"form-group"}>
              <label> Current Profession </label>
              <select
                value={currentProfession}
                onChange={e => setCurrentProfession(e.target.value)}
              >
                {
                  ProfessionOptions.options.map(option => <option key={option.key} value={option.key}> { option.display } </option>)
                }
              </select>
            </div>
          )
        }
        <div className="form-group">
          <label>Lead Stage</label>
          <select
            className="form-control"
            id="leadStageValue"
            onChange={(e) => setNewLeadStage(e.target.value)}
          >
            {
              LeadStageOptions.map((stage) => (
                <option
                  value={stage.value}
                  selected={isEqual(newLeadStage, stage.value)}
                >
                  {stage.display }
                </option>
              ))
            }
          </select>
          { isFormValid && (
            <button
              onClick={() => onSubmit(updateValue, newLeadStage, actionType, demoDate, callResult, currentIndustry,
              currentExperience, currentProfession )}
              className="btn btn-primary"
            >
              Save
            </button>
          )
          }
        </div>
      </Modal.Body>
    </Modal>
  )
}

function isEqual(selectedValue, currentValue) {
  return selectedValue === currentValue;
}

export default UpdateLeadForm;
